export const browser = {
  get window() {
    return typeof window === "undefined" ? null : window;
  },
};
